<app-preloader *ngIf="loading" type="sk-fading-circle"></app-preloader>
<app-bs4-alert *ngIf="errorShow" [message]="errorMessage" [messages]="errorMessages" type="danger"></app-bs4-alert>
<app-bs4-alert *ngIf="confirmed" message="Your e-mail has been confirmed!<br>You can sign in." type="success"></app-bs4-alert>